'use client'

import React from 'react'
import styles from './LikeButton.module.scss'
import Button from '@mui/material/Button'
import ThumbUpOffAltIcon from '@mui/icons-material/ThumbUpOffAlt'
import Dialog from '@mui/material/Dialog'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import DialogTitle from '@mui/material/DialogTitle'
import Slide from '@mui/material/Slide'
import { TransitionProps } from '@mui/material/transitions'
import IconButton from '@mui/material/IconButton'
import CloseIcon from '@mui/icons-material/Close'
import { useTranslations } from 'next-intl'
import { IUser } from '@/interfaces/IUser'

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement;
  },
  ref: React.Ref<unknown>
) {
  return <Slide direction="up" ref={ref} {...props} />
})

/**
 * ! likes are passed down as a number from the parent
 */
interface LikeButtonProps {
  postId: string
  likes: number
  user: IUser | null | undefined
  loading: boolean
  sorryModalOpen: boolean
  likeStatus: string
  clickLike: () => Promise<void>
  // eslint-disable-next-line no-unused-vars
  setSorryModalBool: (bool: boolean) => void
}
function LikeButton ({ likeStatus, loading, user, sorryModalOpen, clickLike, setSorryModalBool }: LikeButtonProps) {
  const t = useTranslations('LikeButton')

  console.log({ loading, user, likeStatus })

  if (loading) return null
  if (user === undefined) return null

  return (
    <>
      <div className={styles.wrapper}>
        {likeStatus === 'none' &&
          <Button
            startIcon={<ThumbUpOffAltIcon className={styles.iconColor} />}
            style={{ textTransform: 'none' }}
            className={styles.likeButton}
            onClick={() => clickLike()}
          >
            {t('article-helpful')}
          </Button>
        }
      </div>
      <Dialog
        open={sorryModalOpen}
        TransitionComponent={Transition}
        keepMounted
        onClose={() => setSorryModalBool(false)}
        aria-describedby='alert-dialog-sorry'
      >
        <DialogTitle>{t('invalid-request')}</DialogTitle>
        <IconButton
          aria-label="close"
          onClick={() => setSorryModalBool(false)}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500]
          }}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent>
          <DialogContentText id='alert-dialog-sorry' style={{ minWidth: '300px', minHeight: '50px' }}>
            {t('must-be-logged-in')}
          </DialogContentText>
        </DialogContent>
      </Dialog>
    </>
  )
}

export default LikeButton
